import persistentStore from '../persistentStore'

/**
 * Creates an object containing user API service methods.
 *
 * @param {string} baseUrl - The base URL for the API.
 * @returns {Object} An object with methods to interact with the user API.
 * @property {Function} getBySlugSeller - Fetches user notification data by seller slug.
 * @property {Function.getBySlugSeller} getBySlugSeller
 * @param {Object} params - Parameters for the request.
 * @param {string} params.slugSeller - The slug of the seller.
 * @returns {Promise<Object>} A promise that resolves to the response data.
 */
const userApiServices = baseUrl => ({
  getBySlugSeller: async ({ slugSeller }) => {
    const response = await fetch(`${baseUrl}/user/notify/${slugSeller}`, {
      headers: {
        authorization: persistentStore.getToken(),
        app: process.env.REACT_APP_APPLICATION_NAME || 'backOffice',
        'api-key': process.env.REACT_APP_SECURITY_API_KEY
      }
    })

    const data = await response.json()
    return data
  }
})

export default userApiServices(process.env.REACT_APP_USER_API_PATH)
